// DeleteAccount.container: agency membership withdrawal; DELETE /my-info/agency with password unless flow changes.
// Mistake: INCORRECT_PASSWORD triggered a second alert after Auth.api errorHandler already showed the API message—removed duplicate.
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as AuthApi from "api/common/Auth.api";

import DeleteAccountComponent from "./DeleteAccount.component";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const DeleteAccountContainer = (props: any) => {
  const { info: myInfo } = useSelector((state: any) => state.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [withdrawalReasonCode, setWithdrawalReasonCode] = useState("");
  const [withdrawalOtherReason, setWithdrawalOtherReason] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)
  const [password, setPassword] = useState("");

  const deleteAccount = async () => {

    if (window.confirm(getLanguageValue(PAGE_TYPE.COMMON, "deleteAccount.txtConfirm"))) {
      setIsButtonDisabled(true)

      try {
        const result = await AuthApi.deleteAgencyAccount(
          password, "withdrawalReason:etc", withdrawalOtherReason);

        if (result?.status === 200) {
          navigate("/logout");
          return;
        }
        // Wrong password and other 400s: errorHandler already alerted with API message.
      } catch (error) {
        console.error('Failed to delete account:', error);
        alert("Failed to delete account, try again later.");
      } finally {
        setIsButtonDisabled(false)
      }
    }
  };

  return (
    <DeleteAccountComponent
      onClickBtnDeleteAccount={deleteAccount}
      setWithdrawalReasonCode={setWithdrawalReasonCode}
      setWithdrawalOtherReason={setWithdrawalOtherReason}
      isButtonDisabled={isButtonDisabled}
      password={password}
      setPassword={setPassword}
    />
  );
};

export default DeleteAccountContainer;
